module.exports = __webpack_public_path__ + "img/three3Blue.1005ccfa.jpg";